import React from 'react'
import styles from './GPSTracker.module.css'
import Layout from '../components/Layout'
import globalStyles from '../styles/global.module.css'

const GPSTracker = () => {
  return (
    <Layout>
      <div className={globalStyles.container} style={{ paddingTop: '1em', width: '100%' }}>
        <div className={globalStyles.card} style={{ paddingTop: '.5em' }}>
          <h2>Satellite Tracker</h2>
          <div className={styles.iframeContainer}>
            <iframe 
              src="https://share.garmin.com/maximi" 
              frameBorder="0" 
              marginWidth="0" 
              marginHeight="0" 
              width="100%" 
              height="760" 
              title="GPS Tracker"
              className={styles.trackerIframe}
            />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default GPSTracker 